"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var numberLookupMap = {
    0.1: {
        vulgar: '⅒',
        fraction: '1/10',
    },
    0.11: {
        vulgar: '⅑',
        fraction: '1/9',
    },
    0.12: {
        vulgar: '⅛',
        fraction: '1/8',
    },
    0.14: {
        vulgar: '⅐',
        fraction: '1/7',
    },
    0.16: {
        vulgar: '⅙',
        fraction: '1/6',
    },
    0.2: {
        vulgar: '⅕',
        fraction: '1/5',
    },
    0.25: {
        vulgar: '¼',
        fraction: '1/4',
    },
    0.33: {
        vulgar: '⅓',
        fraction: '1/3',
    },
    0.37: {
        vulgar: '⅜',
        fraction: '3/8',
    },
    0.4: {
        vulgar: '⅖',
        fraction: '2/5',
    },
    0.5: {
        vulgar: '½',
        fraction: '1/2',
    },
    0.6: {
        vulgar: '⅗',
        fraction: '3/5',
    },
    0.62: {
        vulgar: '⅝',
        fraction: '5/8',
    },
    0.66: {
        vulgar: '⅔',
        fraction: '2/3',
    },
    0.75: {
        vulgar: '¾',
        fraction: '3/4',
    },
    0.8: {
        vulgar: '⅘',
        fraction: '4/5',
    },
    0.83: {
        vulgar: '⅚',
        fraction: '5/6',
    },
    0.87: {
        vulgar: '⅞',
        fraction: '7/8',
    },
};
exports.default = numberLookupMap;
